document.addEventListener('DOMContentLoaded', function () {
    const handleClick = event => {
        const el = event.currentTarget;
        const eventName = el.dataset.event;
        if (!eventName) return;

        event.preventDefault();
        const item = {
            item_id: el.dataset.itemId,
            item_name: el.dataset.itemName,
            item_brand: el.dataset.itemBrand,
            item_category: el.dataset.itemCategory,
            item_category2: el.dataset.itemCategory2,
            item_category3: el.dataset.itemCategory3,
            item_category4: el.dataset.itemCategory4,
            item_list_id: el.dataset.itemListId,
            item_list_name: el.dataset.itemListName,
        };

        const payload =
            eventName === 'bilety_belka_click'
                ? {
                      event: eventName,
                      ecommerce: {
                          items: [item],
                      },
                  }
                : {
                      event: eventName,
                      item_name: item.item_name,
                      item_list_id: item.item_list_id,
                      item_list_name: item.item_list_name,
                  };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);

        if (el.tagName.toLowerCase() === 'a' && el.href) {
            const target = el.target;

            setTimeout(() => {
                if (target === '_blank') {
                    window.open(el.href, '_blank');
                } else {
                    window.location.href = el.href;
                }
            }, 200);
        }
    };

    document.querySelectorAll('[data-event]').forEach(el => {
        el.addEventListener('click', handleClick);
    });
});
